// FILE: /src/Components/BuySubscription/UpgradeModal.js (NEW FILE)

import React from 'react';
import { Modal, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ExclamationCircleFilled } from '@ant-design/icons';

const UpgradeModal = ({ isOpen, onClose, featureName, message }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    onClose();
    navigate('/select-plan');
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      width={450}
    >
      <div className="text-center p-6">
        <ExclamationCircleFilled className="text-yellow-500 text-5xl mb-4" />
        <h2 className="text-xl font-bold text-gray-800 mb-2">
          {`Upgrade to Continue Using ${featureName}`}
        </h2>
        <p className="text-gray-600 mb-6">
          {message || 'You have reached the usage limit for this feature on your current plan.'}
        </p>
        <div className="flex justify-center gap-4">
          <Button onClick={onClose}>
            Maybe Later
          </Button>
          <Button type="primary" onClick={handleUpgrade}>
            View Plans & Upgrade
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UpgradeModal;